// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__dxc3U","emails":"CreateEditClinics_emails__3mmO2","emailTagLabel":"CreateEditClinics_emailTagLabel__8ZEQM"};